import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

const ABOUT_IMG = "https://static.prod-images.emergentagent.com/jobs/ccab85ca-bf95-4b72-aac4-cda44cdf7c03/images/4190f3c52537707140d3008386eb697e3f1afcde485b5d9691ec0c87e530d1c2.png";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export default function AboutSection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <motion.div
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={{
              visible: { transition: { staggerChildren: 0.15 } },
            }}
          >
            <motion.p variants={fadeUp} className="text-sm uppercase tracking-[0.2em] font-medium text-[#0077D1] mb-4">
              Who We Are
            </motion.p>
            <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.2] font-semibold text-[#0C3A72] mb-6">
              Powering India's Aviation with Indigenous Excellence
            </motion.h2>
            <motion.div variants={fadeUp} className="section-divider mb-8" />
            <motion.p variants={fadeUp} className="text-base leading-relaxed text-[#4A627E] mb-6">
OZO AeroCare,is a R&D-focused company dedicated exclusively to aviation chemical solutions. Our products are benchmarked against leading international alternatives and are proudly manufactured in India with OEM certifications and independent testing to ensure world-class quality and performance.            </motion.p>
            <motion.p variants={fadeUp} className="text-base leading-relaxed text-[#4A627E] mb-8">
              With continuous OEM-aligned research and a six-product development pipeline, we are building India's most comprehensive indigenous aviation chemistry portfolio.
            </motion.p>

            {/* Mission */}
            <motion.div variants={fadeUp} className="border-l-2 border-[#0077D1] pl-6 py-2">
              <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#0077D1] mb-2">Our Mission</p>
              <p className="text-base leading-relaxed text-[#0C3A72] italic">
                "To power India's aviation industry with world-class, indigenously manufactured chemical solutions that deliver OEM-grade compliance with zero import dependency."
              </p>
            </motion.div>

            {/* Key Stats */}
            {/* <motion.div variants={fadeUp} className="mt-10 grid grid-cols-3 gap-6">
              <StatItem number="2" label="OEM Certifications" />
              <StatItem number="6" label="Product Pipeline" />
              <StatItem number="2" label="ISO Standards" />
            </motion.div> */}
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
            className="relative"
          >
            <div className="img-zoom-container relative">
              <img
                src={ABOUT_IMG}
                alt="Aircraft cleaning operations"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
            {/* Floating Badge */}
            {/* <div className="absolute -bottom-6 -left-6 bg-[#0C3A72] text-[#F7F4EC] p-6 hidden lg:block">
              <p className="cert-badge text-xs tracking-wider mb-1 text-[#0077D1]">TESTED BY</p>
              <p className="text-sm font-semibold">SMI Inc., Miami, USA</p>
              <p className="text-xs text-[#F7F4EC]/70 mt-1">Independent Laboratory</p>
            </div> */}
          </motion.div>
        </div>
      </div>
    </section>
  );
}

function StatItem({ number, label }) {
  return (
    <div>
      <p className="text-3xl font-bold text-[#0077D1]">{number}</p>
      <p className="text-sm text-[#4A627E] mt-1">{label}</p>
    </div>
  );
}
